import { render, staticRenderFns } from "./PeersCountRating.vue?vue&type=template&id=ffdcb96a&scoped=true"
import script from "./PeersCountRating.vue?vue&type=script&lang=js"
export * from "./PeersCountRating.vue?vue&type=script&lang=js"
import style0 from "./PeersCountRating.vue?vue&type=style&index=0&id=ffdcb96a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdcb96a",
  null
  
)

export default component.exports